import { hasEvent, isReservation } from '../apiHelpers';
import { useReservationServiceContext } from '../state/ReservationServiceContext';
import styles from './OccupantGroups.scss';
import { OccupantsAccordion } from './OccupantsAccordion';
import { filterOccupantsByEvent, groupOccupantsByStatus } from './utils';

export const OccupantGroups = () => {
  const { occupants, selectedEventId } = useReservationServiceContext();

  if (!occupants.length) {
    return (
      <div className={styles.noContent}>
        There are no occupants to display for this date.
      </div>
    );
  }

  const visibleOccupants = filterOccupantsByEvent(occupants, selectedEventId);

  if (!visibleOccupants.length) {
    return (
      <div className={styles.noContent}>
        There are no occupants to display for this event.
      </div>
    );
  }

  const { seated, upcoming, admitted, finished, removed } =
    groupOccupantsByStatus(visibleOccupants);

  const hasEventReservationsToday = occupants.some(
    (occupant) => isReservation(occupant) && hasEvent(occupant),
  );

  return (
    <div
      className={styles.listWrapper}
      data-testid="occupant-groups-wrapper"
      id="occupant-groups-wrapper"
    >
      <OccupantsAccordion title="Reservations" occupants={upcoming} />
      <OccupantsAccordion title="Seated" occupants={seated} />
      {hasEventReservationsToday && (
        <OccupantsAccordion title="Admitted" occupants={admitted} />
      )}
      <OccupantsAccordion title="Finished" occupants={finished} />
      <OccupantsAccordion title="Removed" occupants={removed} />
    </div>
  );
};
